import { tv } from "tailwind-variants";

export const title = tv({
  base: "tracking-tight inline font-semibold",
  variants: {
    color: {
      violet: "from-[#FF1CF7] to-[#b249f8]",
      yellow: "from-[#FF705B] to-[#FFB457]",
      blue: "from-[#5EA2EF] to-[#0072F5]",
      cyan: "from-[#00b7fa] to-[#01cfea]",
      green: "from-[#6FEE8D] to-[#17c964]",
      pink: "from-[#FF72E1] to-[#F54C7A]",
      foreground: "dark:from-[#FFFFFF] dark:to-[#4B4B4B]",
    },
    size: {
      sm: "text-2xl lg:text-3xl",
      md: "text-3xl lg:text-4xl",
      lg: "text-4xl lg:text-5xl",
    },
    fullWidth: {
      true: "w-full block",
    },
  },
  defaultVariants: {
    size: "md",
  },
  compoundVariants: [
    {
      color: [
        "violet",
        "yellow",
        "blue",
        "cyan",
        "green",
        "pink",
        "foreground",
      ],
      class: "bg-clip-text text-transparent bg-gradient-to-b",
    },
  ],
});

export const subtitle = tv({
  base: "w-full md:w-1/2 my-2 text-lg lg:text-xl text-default-600 block max-w-full",
  variants: {
    fullWidth: {
      true: "!w-full",
    },
  },
  defaultVariants: {
    fullWidth: true,
  },
});

export const card = tv({
  base: "bg-gradient-to-r",
  variants: {
    variant: {
      glass:
        "from-default-50/40 to-default-100/40 dark:from-default-100/30 dark:to-default-200/30 backdrop-blur-sm",
      solid:
        "from-default-50 to-default-100 dark:from-default-100 dark:to-default-200",
      subtle:
        "from-default-50/60 to-default-100/60 dark:from-default-100/40 dark:to-default-200/40 backdrop-blur-sm",
      opaque:
        "from-default-50/90 to-default-100/90 dark:from-default-100/80 dark:to-default-200/80",
    },
    size: {
      sm: "p-1",
      md: "p-2",
      lg: "p-4",
    },
    bordered: {
      true: "border border-default-200",
      false: "",
    },
    elevation: {
      none: "shadow-none",
      sm: "shadow-sm",
      md: "shadow-md",
      lg: "shadow-lg",
    },
  },
  defaultVariants: {
    variant: "glass",
    size: "lg",
    elevation: "none",
  },
});
